import styled, { css } from 'styled-components';
import { ToolTip, ToolTipPosition } from '@libs/components';

type ToolTipProps = {
  position?: ToolTipPosition;
};
export const CustomTooltip = styled(ToolTip)<ToolTipProps>`
  .desc {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
  svg {
    width: 2.2rem;
    height: 2.2rem;
  }
  .tooltipbox {
    position: absolute;
    left: -2.3rem;
    display: none;
    background-color: transparent;
    padding-top: 3.8rem;
    min-width: 31.4rem;
    width: 100%;
    z-index: ${({ theme }) => theme.zIndex.high};

    ${({ position }) =>
      position === 'top'
        ? css`
            bottom: calc(100% - 2.3rem);
          `
        : css`
            top: calc(100% - 2.3rem);
          `};
  }
  .tooltip {
    border-radius: ${({ theme }) => theme.borderRadius.x2};
    &:after {
      border-bottom-right-radius: 0.4rem;
      /* bottom: calc(100% - 0.85rem); */
      height: 1.7rem;
      width: 1.7rem;
      right: unset;
      left: 2.5rem;
      border: 0.1rem solid #d5dce5;
      ${({ position }) =>
        position === 'top'
          ? css`
              top: calc(100% - 0.85rem);
              transform: rotate(45deg);

              border-bottom-right-radius: 0.2rem;
              border-top: none;
              border-left: none;
            `
          : css`
              top: -0.95rem;

              transform: rotate(45deg);

              border-top-left-radius: 0.2rem;
              border-bottom: none;
              border-right: none;
            `}
    }
    .tooltipHeader {
      padding: 2.2rem 2rem;
    }
  }
`;
